import { SaleGuide } from "./SalePriceGuideType";

/**
 * PAY-2297の対応で追加した国内向けセール表示用のデータ
 *  FIXME: plan-optionのセールアピール文言で、国内セールの日本語のみ柔軟に変えられるようにしている。
 *   - もとは価格表示などもあったが、それらはPlanOptionConst参照にした
 *   - 文言もdev.php管理にするなどできそうだが、工数がかかりそうなのでまだやっていない
 * */
export const singlePaymentJapanSaleList: SaleGuide[] = [
  {
    // V1PRO -> V2PRO バージョンアップ
    fromPlanCategory: "from_pro_v1",
    planKey: "to_pro_v2",
    text: "優待バージョンアップ"
  },
  {
    // V1PRO -> V2EX アップグレード
    fromPlanCategory: "from_pro_v1",
    planKey: "to_ex_v2",
    text: "アップグレード優待"
  },
  {
    // V1EX -> V2EX バージョンアップ
    fromPlanCategory: "from_ex_v1",
    planKey: "to_ex_v2",
    text: "優待バージョンアップ"
  },
  {
    // V2PRO -> V2EX アップグレード
    // memo: 終売済みだが、復活する可能性も一応ある
    fromPlanCategory: "from_pro_v2",
    planKey: "to_ex_v2",
    text: "アップグレード優待"
  },
  {
    // V2PRO -> V3PRO バージョンアップ
    fromPlanCategory: "from_pro_v2",
    planKey: "to_pro_v3",
    text: "優待バージョンアップ"
  },
  {
    // V2PRO -> V3EX アップグレード
    fromPlanCategory: "from_pro_v2",
    planKey: "to_ex_v3",
    text: "アップグレード優待"
  },
  {
    // V2EX -> V3EX バージョンアップ
    fromPlanCategory: "from_ex_v2",
    planKey: "to_ex_v3",
    text: "優待バージョンアップ"
  },
  {
    // V3PRO -> V3EX アップグレード
    fromPlanCategory: "from_pro_v3",
    planKey: "to_ex_v3",
    text: "アップグレード優待"
  },
  {
    // V3PRO -> V4PRO バージョンアップ
    fromPlanCategory: "from_pro_v3",
    planKey: "to_pro_v4",
    text: "優待バージョンアップ"
  },
  {
    // V3PRO -> V4EX アップグレード
    fromPlanCategory: "from_pro_v3",
    planKey: "to_ex_v4",
    text: "アップグレード優待"
  },
  {
    // V3EX -> V4EX バージョンアップ
    fromPlanCategory: "from_ex_v3",
    planKey: "to_ex_v4",
    text: "優待バージョンアップ"
  },
  {
    // V4PRO -> V4EX アップグレード
    fromPlanCategory: "from_pro_v4",
    planKey: "to_ex_v4",
    text: "アップグレード優待"
  }
];
